<!--
 * @Description: 电子围栏
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 14:41:29
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <!-- 导航 -->
        <div class="tabtop">
          <div v-for="(item, index) in navlist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
          </div>
        </div>
        <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">工程名称</span>
                <el-input v-model="tableParam.name" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span v-if="currenindex == 1" style="margin-left: 24px">
                <span style="margin-right: 12px">施工单位</span>
                <el-input v-model="tableParam.roadwork" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div v-loading="tableLoading" class="card_info" :style="{ height: screenHeight - 450 }">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" :height="screenHeight - 450" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width">
                  <template slot-scope="scope">
                    <div v-if="item.label == '经纬度坐标'">
                      <span>{{ scope.row.longitude }},{{ scope.row.latitude }}</span>
                      <el-link v-if="ButtonList.findIndex(res => res.buttonValue == 'HUOQU') !== -1" class="table_link" :underline="false" @click="mapVisibleTypeFun(scope.row)">获取</el-link>
                    </div>
                    <div v-else-if="item.label == '工程名称'">
                      <span style="color: #008200; cursor: pointer" @click="datails(scope.row)">{{ scope.row.name }}</span>
                    </div>
                    <div v-else-if="item.label == '泵送单位设置'">
                      <el-link class="table_link" :underline="false" @click="pumpSelect(scope.row)">请选择</el-link>
                    </div>
                    <div v-else-if="item.label == '特殊车辆设置'">
                      <el-link class="table_link" :underline="false" @click="carSelect(scope.row)">请选择</el-link>
                    </div>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 电子围栏 -->
    <el-dialog v-dialogDrag :visible.sync="mapVisible" width="80%" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">地图选点</span>
      <div style="padding-bottom: 20px">
        <el-row>
          <el-col :span="17">
            <div class="amap-page-container">
              <el-amap-search-box ref="amapSearch" default="" class="search-box" :search-option="searchOption" :on-search-result="onSearchResult"></el-amap-search-box>
              <el-amap ref="amapContainer" vid="amapDemo" :zoom="zoom" :events="events" :center="mapCenter" class="amap-demo" style="height: 550px">
                <el-amap-marker :position="markers.position" :events="markers.events" :draggable="markers.draggable"></el-amap-marker>
                <el-amap-circle v-for="(circle, index) in circles" :key="index" :center="circle.center" :radius="circle.radius" :fill-opacity="circle.fillOpacity" :bubble="true"></el-amap-circle>
                <div id="panel"></div>
              </el-amap>
              <div class="toolbar">
                <div>
                  <span style="color:red;font-size: 24px;">电子围栏（米）</span>
                  <el-input
                    v-model="formMap.distance"
                    :max="1000"
                    onkeypress="return( /\d/.test(String.fromCharCode(event.keyCode)))"
                    @input="update_distanceFun0()"
                    @blur="formMap.distance = $regExp.blurCheckNum(formMap.distance)"
                  ></el-input>
                </div>
                position: {{ markers.position }} address: {{ address }} 当前选择站点:{{ stationName }}
              </div>
            </div>
          </el-col>
          <el-col :span="6" :offset="1">
            <span>项目:{{ mapEngineering }}</span><span style="color:red">(点击查看最短距离)</span>
            <el-table
              :header-cell-style="{ background: '#f3f6f9' }"
              height="550px"
              :cell-style="{ borderRight: 'none' }"
              border
              stripe
              style="width: 100%"
              :data="StationToEngineeringDistanceData"
              tooltip-effect="dark"
              @row-click="selectStation"
            >
              <el-table-column label="站点" width="auto" align="center" prop="stationName"></el-table-column>
              <el-table-column label="最短距离" width="auto" align="center" prop="distance"></el-table-column>
              <el-table-column label="油车调整距离" width="auto" align="center" prop="adjustDistance">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.adjustDistance"
                    :disabled="scope.row.disabled"
                    placeholder="请输入"
                    style="width: 100%"
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                    @blur="saveAdjustDistance(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="电车调整距离" width="auto" align="center" prop="adjustDistance">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.tramDistance"
                    :disabled="scope.row.disabled"
                    placeholder="请输入"
                    style="width: 100%"
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                    @blur="saveAdjustDistance(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="mapVisible = false">取 消</el-button>
        <el-button
          v-if="currenindex == 1 ? (pointIds.find(item => item == low.stationId) ? true : false) : true"
          class="bottom_all"
          :disabled="markers.position[0] == low.longitude && markers.position[1] == low.latitude"
          style="margin-left: 24px"
          @click="savepoint()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看工程 -->
    <el-dialog v-dialogDrag :visible.sync="show" width="1085px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">工程信息</span>
      <div class="dialoginfo show">
        <el-form :inline="true" label-width="110px">
          <div class="form-title">工程基本信息</div>
          <el-form-item prop="name">
            <span slot="label" style="color: #ff0000">工程名称</span>
            <el-input v-model="fromDate.name" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item prop="place">
            <span slot="label" style="color: #ff0000">地理位置</span>
            <el-input v-model="fromDate.place" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item prop="expectedAmount" label-width="160px">
            <span slot="label" style="color: #ff0000">预估用砼量（方）</span>
            <el-input v-model="fromDate.expectedAmount" style="width: 176px" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item prop="typeId">
            <span slot="label">工程性质</span>
            <el-input v-model="fromDate.type" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item prop="rateOfProgressId">
            <span slot="label">项目进度</span>
            <el-input v-model="fromDate.rateOfProgress" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item prop="startTime">
            <span slot="label">起供时间</span>
            <el-date-picker v-model="fromDate.startTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" disabled></el-date-picker>
          </el-form-item>
          <el-form-item prop="tubularColumn">
            <span slot="label">管柱（米）</span>
            <el-input v-model="fromDate.tubularColumn" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item prop="fabricated">
            <span slot="label">装配式</span>
            <el-input v-model="fromDate.fabricated" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item prop="fabricated">
            <span slot="label">现场情况</span>
            <el-input v-model="fromDate.currentSituation" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <div>
            <el-form-item prop="roadwork">
              <span slot="label" style="color: #ff0000">施工单位</span>
              <el-input v-model="fromDate.roadwork" placeholder="请输入" disabled></el-input>
            </el-form-item>
            <el-form-item prop="roadworklInkman">
              <span slot="label" style="color: #ff0000">联系人</span>
              <el-input v-model="fromDate.roadworklInkman" placeholder="请输入" disabled></el-input>
            </el-form-item>
            <el-form-item prop="roadworkPhone">
              <span slot="label" style="color: #ff0000">电话</span>
              <el-input v-model="fromDate.roadworkPhone" placeholder="请输入" disabled></el-input>
            </el-form-item>
            <el-form-item prop="constructionUnit">
              <span slot="label">建设单位</span>
              <el-input v-model="fromDate.constructionUnit" placeholder="请输入" disabled></el-input>
            </el-form-item>
            <el-form-item prop="cuLinkman">
              <span slot="label">联系人</span>
              <el-input v-model="fromDate.cuLinkman" placeholder="请输入" disabled></el-input>
            </el-form-item>
            <el-form-item prop="cuPhone">
              <span slot="label">电话</span>
              <el-input v-model="fromDate.cuPhone" placeholder="请输入" disabled></el-input>
            </el-form-item>
            <el-form-item prop="contractSigningUnit">
              <span slot="label">合同单位</span>
              <el-input v-model="fromDate.contractSigningUnit" placeholder="请输入" disabled></el-input>
            </el-form-item>
            <el-form-item prop="clientTypeId">
              <span slot="label">客户类型</span>
              <el-input v-model="fromDate.clientType" placeholder="请输入" disabled></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item prop="businessTypeId">
              <span slot="label" style="color: #ff0000">业务类型</span>
              <el-input v-model="fromDate.businesName" placeholder="请输入" disabled></el-input>
            </el-form-item>
            <el-form-item prop="executePhase">
              <span slot="label" style="color: #ff0000">执行阶段</span>
              <el-select v-model="fromDate.executePhase" placeholder="请选择" disabled>
                <el-option label="委托交底" :value="1"></el-option>
                <el-option label="评估" :value="2"></el-option>
                <el-option label="投标" :value="3"></el-option>
                <el-option label="合同交底" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item prop="remark">
            <span slot="label">备注</span>
            <el-input v-model="fromDate.remark" style="width: 920px" type="textarea" :rows="5" resize="none" placeholder="请输入" disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="show = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 泵送单位选择 -->
    <el-dialog v-dialogDrag :visible.sync="pumpSetDig" width="900px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">泵送单位设置</span>
      <div class="dialoginfo show">
        <el-button class="bottom_all" @click="addItem()">添 加</el-button>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" height="550px" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="pumpSetData" tooltip-effect="dark">
          <el-table-column label="浇筑方式" width="auto" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.pumpMethod" multiple filterable placeholder="请选择">
                <el-option v-for="item in pumpMethodList" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="泵送单位" width="auto" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.pumpId" placeholder="请选择" filterable>
                <el-option
                  v-for="item in pumpUnitList"
                  :key="item.id"
                  :label="item.contractNumber + '_' + item.supplierName + '_' + item.cooperationClass + '_' + item.contractSigningSubject"
                  :value="item.contractId"
                  @click.native="choosePumpUnit(scope.$index, item)"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="auto" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="deletePump(scope.$index)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="pumpSetDig = false">取 消</el-button>
        <el-button class="bottom_all" @click="savePumpSet()">保 存</el-button>
      </span>
    </el-dialog>
    <!--  特殊车辆设置 -->
    <carSet ref="carSet" :dialog.sync="carSetDig" :centerRow="low"
            @resetCar="carSetDig = false"  />
  </div>
</template>
<script>
import axios from "axios";
import mixin from "@/mixins/ICPSmixin.js";
import { QueryOneByid } from "@/api/internetSales/chanceManagement.js";
import { getUserInfo } from "@/utils/auth.js";
import { queryPage, queryPage2, update_long_lat, update_distance, getStationToEngineeringDistance, updateStationToEngineeringDistance, pumpSetQuery, pumpSetSave } from "@/api/smart/schedul/a.js";
import { getContractVoList } from "@/api/smart/schedul/d.js";
import { getDicType } from "@/api/common.js";
import  carSet  from "./components/carSet.vue";
import { setTimeout } from "timers";
export default {
  mixins: [mixin],
  components: {
    carSet
    },
  data() {
    let _this = this;
    return {
      circles: [],
      fromDate: {},
      show: false,
      low: {}, //当前行数据
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      /*表格数据*/
      table: [],
      table1: [
        { label: "工程编码", width: "140", prop: "code", status: true },
        { label: "工程名称", width: "220", prop: "name", status: true },
        {
          label: "经纬度坐标",
          width: "250",
          prop: "",
          status: true,
        },
        { label: "施工单位", width: "220", prop: "roadwork", status: true },
        {
          label: "联系人",
          width: "140",
          prop: "roadworklInkman",
          status: true,
        },
        {
          label: "联系电话",
          width: "140",
          prop: "roadworkPhone",
          status: true,
        },
        {
          label: "登记时间",
          width: "160",
          prop: "startTime",
          status: true,
        },
        { label: "负责人", width: "140", prop: "principal", status: true },
        {
          label: "地理位置",
          width: "160",
          prop: "place",
          status: true,
        },
        {
          label: "经纬度地址",
          width: "150",
          prop: "address",
          status: true,
        },
        { label: "电子围栏(米)", width: "140", prop: "distance", status: true },
        { label: "泵送单位设置", width: "140", prop: "", status: true },
        { label: "特殊车辆设置", width: "140", prop: "", status: true },
      ],
      table2: [
        { label: "工程编码", width: "140", prop: "code", status: true },
        { label: "工程名称", width: "220", prop: "name", status: true },
        {
          label: "经纬度坐标",
          width: "250",
          prop: "",
          status: true,
        },
        // { label: "施工单位", width: "220", prop: "roadwork", status: true },
        {
          label: "联系人",
          width: "140",
          prop: "roadworklInkman",
          status: true,
        },
        {
          label: "联系电话",
          width: "140",
          prop: "roadworkPhone",
          status: true,
        },
        {
          label: "登记时间",
          width: "160",
          prop: "startTime",
          status: true,
        },
        { label: "负责人", width: "140", prop: "principal", status: true },
        {
          label: "地理位置",
          width: "160",
          prop: "place",
          status: true,
        },
        {
          label: "经纬度地址",
          width: "150",
          prop: "address",
          status: true,
        },
        { label: "电子围栏(米)", width: "140", prop: "distance", status: true },
        { label: "泵送单位设置", width: "140", prop: "", status: true },
        { label: "特殊车辆设置", width: "140", prop: "", status: true },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      point: "",
      mapVisible: false,
      companylist: [],
      principalarr: [],
      /*公用数据*/
      id: "",
      list: [],
      /*地图*/
      zoom: 12,
      mapCenter: [104.065637, 30.657717],
      map: null,
      driving: null,
      loaded: false,
      address: "逸都国际",
      events: {
        click: e => {
          _this.markers.position = [e.lnglat.lng, e.lnglat.lat];
          _this.getaddress(_this.markers.position);
          if (_this.driving) {
            _this.driving.clear();
            _this.drivingMap();
          }
        },
      },
      markers: {
        position: [1, 1],
        events: {
          dragend: e => {
            console.log(e);
            axios.get(`https://restapi.amap.com/v4/geocode/regeo?key=1ce84487b2aa51d790cac6e356046c5b&location=${e.lnglat.lng},${e.lnglat.lat}`).then(res => {
              this.address = res.data.regeocode.formatted_address;
            });
            _this.markers.position = [e.lnglat.lng, e.lnglat.lat];
            console.log(1, this.circles.length > 0);
            if (this.circles.length > 0) {
              this.circles[0].center = _this.markers.position;
            }
          },
        },
        draggable: true,
      },
      station: [],
      stationName: "",
      waypoints: [],
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      mapVisibleK: "",
      formMap: {
        id: "",
        distance: "",
      },
      StationToEngineeringDistanceData: [], //站点项目电子围栏距离数据
      mapEngineering: "",
      /**导航栏*/
      navlist: [
        {
          value: "非生产处登记",
          id: 1,
        },
        {
          value: "生产处登记",
          id: 2,
        },
      ],
      currenindex: 1,
      pointIds: [],
      pumpSetDig: false,
      pumpUnitList: [],
      pumpMethodList: [],
      pumpSetData: [],
      carSetDig:false,
    };
  },
  watch: {
    /**导航切换*/
    currenindex: {
      handler() {
        this.tableData = [];
        this.tableParam = this.$options.data().tableParam;
        if (this.currenindex == 1) {
          this.table = this.table1;
          this.queryPage = queryPage;
          this.gettableData();
        }
        if (this.currenindex == 2) {
          this.table = this.table2;
          this.queryPage = queryPage2;
          this.gettableData();
        }
        this.tableLoading = false;
        //此处为执行的函数或者方法
      },
      deep: false,
      immediate: true,
    },
  },
  async created() {
    this.pointIds = await getUserInfo().pointIds;
  },
  mounted() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = {
      ...this.tableParam,
      id: "",
      stationName: "",
      isAssess: "5",
    };
    this.gettableData();
  },
  methods: {
    carSelect(row){
      this.low = JSON.parse(JSON.stringify(row))
      this.carSetDig = true
    },
    choosePumpUnit(rowIndex, item) {
      this.pumpSetData[rowIndex].pumpName = item.contractNumber + ":" + item.supplierName;
      this.pumpSetData[rowIndex].pumpDataType = item.dataType;
    },

    //保存泵送单位设置
    savePumpSet() {
      this.pumpSetData.forEach(item => {
        item.pourings = [];
        item.pumpMethod.forEach(item2 => {
          let pumpItem = this.pumpMethodList.find(item3 => item3.id == item2);
          item.pourings.push({
            pouringType: pumpItem.itemName,
            pouringTypeId: pumpItem.id,
          });
        });
      });
      let params = {
        projectId: this.low.id,
        list: this.pumpSetData,
      };
      pumpSetSave(params).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
          this.pumpSetDig = false;
          this.gettableData();
        }
      });
    },
    //添加泵送单位
    addItem() {
      let obj = {
        projectId: this.low.id,
        projectName: this.low.name,
        pumpId: "",
        pumpName: "",
        pumpMethod: [],
        pumpDataType: "",
      };
      this.pumpSetData.push(obj);
    },
    //删除泵送单位
    deletePump(index) {
      this.pumpSetData.splice(index, 1);
    },
    //选择泵送单位
    async pumpSelect(row) {
      this.low = row;
      getContractVoList({ stationId: row.stationId, contractTypeId: 3, facilityType: 1 }).then(res => {
        this.pumpUnitList = res.data;
      });
      getDicType({
        code: "castingType",
      }).then(res => {
        this.pumpMethodList = res.data.items;
      });
      await this.pumpSetQuery();
      this.pumpSetDig = true;
    },
    //获取泵送单位设置列表
    pumpSetQuery() {
      pumpSetQuery({ projectId: this.low.id }).then(res => {
        if (res.code == 1001) {
          this.pumpSetData = [];
          res.data.forEach(item => {
            let obj = {
              projectId: item.projectId,
              projectName: item.projectName,
              pumpId: item.pumpId,
              pumpName: item.pumpName,
              pumpDataType: item.pumpDataType,
              pumpMethod: item.pourings.map(item => {
                return item.pouringTypeId;
              }),
            };
            this.pumpSetData.push(obj);
          });
        }
      });
    },
    // 点击选择站点行
    selectStation(row) {
      let station = row.stationLongitudeLatitude.split(",");
      this.stationName = row.stationName;
      if (station.length > 1) {
        this.station[0] = Number(station[0]);
        this.station[1] = Number(station[1]);
      }
      console.log(this.station);
      if (this.driving) {
        this.driving.clear();
      }
      this.drivingMap();
    },
    //路线规划
    drivingMap() {
      if (this.station.length > 1) {
        this.map = this.$refs.amapContainer.$$getInstance();
        console.log(AMap.DrivingPolicy);
        this.driving = new AMap.Driving({
          map: this.map,
          // policy: AMap.DrivingPolicy.LEAST_TIME, //最快捷模式
          panel: "panel",
          policy: AMap.DrivingPolicy.LEAST_DISTANCE, //最短距离模式
          //policy: AMap.DrivingPolicy.REAL_TRAFFIC,//考虑实时路况
          //policy: AMap.DrivingPolicy.LEAST_FEE,//最经济模式
        });
        this.driving.search(this.station, this.markers.position, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            console.log(result);
          } else {
            console.log(result);
          }
        });
      }
    },

    /**导航栏切换*/
    choose(pages) {
      this.tableLoading = true;
      this.currenindex = pages;
    },
    /*保存地图距离 */
    saveAdjustDistance(row) {
      let params = {
        id: row.id,
        adjustDistance: row.adjustDistance,
        tramDistance:row.tramDistance,
      };
      updateStationToEngineeringDistance(params).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
        } else {
          getStationToEngineeringDistance({ eId: row.engineeringId }).then(res => {
            if (res.code == 1001) {
              this.StationToEngineeringDistanceData = res.data;
              this.$message.success("保存失败,请重新修改!");
            }
          });
        }
      });
    },
    datails(low) {
      QueryOneByid({ id: low.id }).then(res => {
        this.fromDate = res.data;
        this.show = true;
      });
    },
    /**逆向编码*/
    getaddress(lnglat) {
      let _this = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: "全国",
        });
        geocoder.getAddress(lnglat, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            _this.address = result.regeocode.formattedAddress;
            // result为对应的地理位置详细信息
            if (_this.circles.length > 0) {
              _this.circles[0].center = _this.markers.position;
            }
          }
        });
      });
    },
    mapVisibleTypeFun(e) {
      this.mapVisible = true;
      if (this.$refs.amapSearch) {
        this.$refs.amapSearch.keyword = "";
        this.$refs.amapSearch.tips = [];
      }
      this.stationName = "";
      this.$forceUpdate();
      this.low = e;
      this.formMap.id = e.id;
      this.formMap.distance = e.distance;
      this.mapVisibleK = e.id;
      if (e.longitude) {
        this.mapCenter = [e.longitude, e.latitude];
        this.getaddress(this.mapCenter);
      } else {
        setTimeout(() => {
          this.mapCenter = [104.065637, 30.657717];
          this.address = e.place;
        }, 10);
      }
      
      let obj = [
        {
          name: e.place,
          lng: e.longitude,
          lat: e.latitude,
        },
      ];
      console.log(e.distance);
      this.circles = [
        {
          center: [e.longitude, e.latitude],
          radius: e.distance,
          fillOpacity: 0.2,
        },
      ];
      if (this.driving) {
        this.driving.clear();
      }
      this.station = [];
      this.onSearchResult(obj);

      /*获取站点项目电子围栏距离 */
      getStationToEngineeringDistance({ eId: e.id }).then(res => {
        if (res.code == 1001) {
          res.data.forEach(item => {
            let stationId = this.pointIds.find(res => res == item.stationId);
            item["disabled"] = this.currenindex == 1 ? (stationId ? false : true) : false;
          });
          this.StationToEngineeringDistanceData = res.data;
          this.mapEngineering = e.name;
        }
      });
    },
    /*地图*/
    onSearchResult(pois) {
      console.log(this.searchOption);
      let _this = this;
      if (pois.length > 0) {
        _this.address = pois[0].name;
        _this.markers.position = [pois[0].lng, pois[0].lat];
        _this.mapCenter = [pois[0].lng, pois[0].lat];
      }
    },
    savepoint() {
      console.log(0);
      if (this.markers.position.length == 0) {
        this.$message({
          message: "请选择经纬度坐标",
          type: "warning",
        });
        return;
      }
      if (this.formMap.distance == 0 || this.formMap.distance > 1000 || this.formMap.distance < 0 ) {
        this.$message({
          message: "电子围栏范围不能小于等于0或大于1000!",
          type: "warning",
        });
        return;
      }
      this.mapVisible = false;
      let obj = {
        longitude: this.markers.position[0],
        latitude: this.markers.position[1],
        id: this.mapVisibleK,
        address: this.address,
        distance: this.formMap.distance,
      };
      update_long_lat(obj).then(res => {
        if (res.code == 1001) {
          //this.update_distanceFun(this.formMap)
          this.gettableData();
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        }
      });
    },
    update_distanceFun0() {
      console.log(0);
      this.circles[0].radius = this.formMap.distance;
    },
    update_distanceFun(e) {
      let obj = {
        distance: e.distance,
        id: e.id,
      };
      update_distance(obj).then(res => {
        if (res.code == 1001) {
          this.gettableData();
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        }
      });
    },
    /*重置数据*/
    init() {
      this.tableParam.id = "";
      this.tableParam.name = "";
      this.tableParam.roadwork = "";
      this.tableParam.isAssess = "5";
      this.gettableData();
    },
    addline() {
      const data = {
        stationId: this.id,
        name: "",
        output: null,
        type: 1,
        list: [],
      };
      this.lineList.push(data);
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.tabtop {
  width: 381px;
}
.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
}
.toolbar {
  padding-top: 10px;
}
.amap-page-container {
  position: relative;
  height: 570px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
.el-input,
.el-select,
.el-cascader {
  width: 200px;
}
.mapbutton {
  width: 300px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
}
.mapbutton:hover {
  border-color: $bg_color;
  cursor: pointer;
}
.amap-demo {
  height: 400px;
}
</style>
<style type="text/css">
#panel {
  position: absolute;
  background-color: white;
  max-height: 90%;
  overflow-y: auto;
  top: 10px;
  right: 10px;
  width: 280px;
}
#panel .amap-call {
  background-color: #009cf9;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
#panel .amap-lib-driving {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow: hidden;
}
</style>